import blocks from './blocks';
import components from './components';
import traits from './traits';

export default (editor, config) => {
  blocks(editor, config);
  components(editor, config);
  traits(editor, config);
};
